module.exports = __webpack_public_path__ + "static/media/bdgr2_.fb844380.svg";